import { useEffect } from 'react';
import BaseOptionChart from '../../../components/charts/BaseOptionChart';
import { merge } from 'lodash';
import { useState } from 'react';
import dayjs from 'dayjs';
import { Grid, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ReactApexChart from 'react-apexcharts';
import { DEVICETYPES_OCR, checkDeviceTypes } from 'guards/CheckRoles';
import { ChartDataPoint } from 'api';
import { Measure } from '../../../@types/model/device';
import Typography from '@mui/material/Typography';
import BasicModalExpanded from 'components/BasicModalExpanded';
import { RootState, useSelector } from 'redux/store';
import { LoadingButton } from '@mui/lab';
import axiosInstance from 'utils/axios';
import { useSnackbar } from 'notistack';

function DeviceDetailsGraph(props: any) {
  const { device, chartData, chartDatas, refactoredDevice, setDateRangeValue, measures } = props;
  const { t } = useTranslation();
  const [period, setPeriod] = useState<string>('trimestral');
  const [chartDataFinal, setChartDataFinal] = useState<ChartDataPoint[]>([]);
  const [calibration1, setCalibration1] = useState<undefined | Measure>(undefined);
  const [calibration2, setCalibration2] = useState<undefined | Measure>(undefined);
  const [allowCalibration, setAllowCalibration] = useState<boolean>(false);
  const { workspace } = useSelector((state: RootState) => state.workspace);
  const [loading, setLoading] = useState<boolean>(false);
  const [calibrationValue1, setCalibrationValue1] = useState<number>(0);
  const [calibrationValue2, setCalibrationValue2] = useState<number>(0);

  const { enqueueSnackbar } = useSnackbar();

  const [open, setOpen] = useState(false);

  useEffect(() => {
    let chart = chartData;
    if (chartDatas.length > 0) {
      let chart = chartDatas[0];
    }
    setChartDataFinal(chart);
    if (workspace?.modules.includes('manual-calibration')) {
      setAllowCalibration(true);
    }
  }, [chartData, chartDatas]);

  let capacidad = 0;
  device?.attributes.parameters.forEach((param: any) => {
    if (param.identifier === 'capacidad') capacidad = parseInt(param.value);
  });
  if (capacidad === 0) {
    if (checkDeviceTypes(device.attributes.device_type, DEVICETYPES_OCR)) {
      chartData.forEach((serie: any) => {
        serie.data.forEach((dat: any) => {
          if (dat.y > capacidad) {
            capacidad = dat.y;
          }
        });
      });
    }
  }
  const chartOptions: any = merge(BaseOptionChart(), {
    /* xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep']
    }, */
    xaxis: {
      type: 'date',
      tickAmount: 10,
      labels: {
        formatter: function (val: number) {
          return dayjs(val * 1000).format('DD/MM');
        },
        hideOverlappingLabels: true,
        rotate: -45,
        rotateAlways: true,
        trim: false
      },
      tooltip: {
        x: { show: false },
        marker: { show: false }
      }
    },
    yaxis: [
      {
        title: {
          text: `${refactoredDevice?.device_type} (${refactoredDevice?.unit})`
        },
        seriesName: t('Depósito (L)'),
        min: 0,
        max: capacidad,
        decimalsInFloat: 0
      }
    ],
    chart: {
      events: {
        markerClick(e: any, chart?: any, options?: any) {
          let dataPointIndex = options.dataPointIndex;
          if (allowCalibration) {
            if (measures && measures[dataPointIndex]) {
              if (calibration1 === undefined) {
                setCalibration1(measures[dataPointIndex]);
              } else {
                setCalibration2(measures[dataPointIndex]);
                setOpen(true);
              }
            }
          }
        }
      }
    }
  });

  function sendEmailToUpdateCalibration() {
    if (calibrationValue1 === 0 && calibrationValue2 === 0) {
      setLoading(false);
      enqueueSnackbar(t('almost_one_point_different_0'), {
        variant: 'error'
      });
      return;
    }
    axiosInstance
      .put(`/api/v2/device/${device.guid}/calibration`, {
        point1: {
          date: calibration1?.attributes.date.format(),
          data: calibration1?.attributes.data,
          value: calibrationValue1
        },
        point2: {
          date: calibration2?.attributes.date.format(),
          data: calibration2?.attributes.data,
          value: calibrationValue2
        },
        device: {
          guid: device.guid,
          name: device.attributes.name,
          identifier: device.attributes.identifier
        }
      })
      .then((res) => {
        setLoading(false);
        enqueueSnackbar(t('calibration_sended'), {
          variant: 'success'
        });
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  }

  return (
    <Grid item xs={12} sm={7} md={8} id="cuadro-container-graficas">
      <div className="cuadro-redondeado cuadro-gris marginZero" id="cuadro-redondeado">
        <h3>{t('consum_chart')}</h3>
        <div className="tabsRow">
          <div className="tabs">
            <span
              className={'tab' + (period === 'semanal' ? ' selected' : '')}
              onClick={() => {
                setPeriod('semanal');
                setDateRangeValue([dayjs().subtract(7, 'day'), dayjs()]);
              }}
            >
              {t('weekly')}
            </span>
            <span
              className={'tab' + (period === 'mensual' ? ' selected' : '')}
              onClick={() => {
                setPeriod('mensual');
                setDateRangeValue([dayjs().subtract(1, 'month'), dayjs()]);
              }}
            >
              {t('monthly')}
            </span>
            <span
              className={'tab' + (period === 'trimestral' ? ' selected' : '')}
              onClick={() => {
                setPeriod('trimestral');
                setDateRangeValue([dayjs().subtract(3, 'month'), dayjs()]);
              }}
            >
              {t('trimestral')}
            </span>
            <span
              className={'tab' + (period === 'anual' ? ' selected' : '')}
              onClick={() => {
                setPeriod('anual');
                setDateRangeValue([dayjs().subtract(1, 'year'), dayjs()]);
              }}
            >
              {t('annual')}
            </span>
          </div>
        </div>
        <ReactApexChart
          type="line"
          series={chartDataFinal}
          options={chartOptions}
          height={320}
          id="appex-chart-line"
        />
        {allowCalibration ? (
          <div>
            {calibration1 === undefined && <p>{t('calibration_text_1')}</p>}
            {calibration1 !== undefined && calibration2 === undefined && (
              <p>
                {t('click_on')} <b>{t('second_point')}</b> {t('to_complete_calibration')}
              </p>
            )}
          </div>
        ) : null}
      </div>

      <BasicModalExpanded
        open={open}
        handleClose={() => {
          setOpen(false);
          setCalibration1(undefined);
          setCalibration2(undefined);
        }}
        style={{
          width: 'calc(100% - 250px)',
          maxHeight: 'calc(100% - 250px)'
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ marginBottom: '10px' }}
        >
          {t('device_calibration')}
        </Typography>
        <Typography id="modal-modal-title" variant="body2">
          {t('device_calibration_text_1')}
        </Typography>
        <Typography id="modal-modal-title" variant="body2" sx={{ marginBottom: '10px' }}>
          {t('device_calibration_text_2')}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} className="calibration--box">
            <TextField
              id="outlined-basic"
              label={t('point_value_1')}
              variant="outlined"
              type="number"
              onChange={(event) => {
                setCalibrationValue1(parseInt(event.target.value));
              }}
            />
            <div className="calibration--box--datas">
              <div className="calibration--box--datas--data">
                <span className="date">
                  {t('date')}: {calibration1?.attributes.date.format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
              <div className="calibration--box--datas--data">
                {calibration1?.attributes.data.map((data) => {
                  return (
                    <div key={data.name}>
                      {data.name}: {data.value}
                    </div>
                  );
                })}
              </div>
            </div>
          </Grid>
          <Grid item xs={6} className="calibration--box">
            <TextField
              id="outlined-basic"
              label={t('point_value_2')}
              variant="outlined"
              type="number"
              onChange={(event) => {
                setCalibrationValue2(parseInt(event.target.value));
              }}
            />
            <div className="calibration--box--datas">
              <div className="calibration--box--datas--data">
                <span className="date">
                  {t('date')}: {calibration2?.attributes.date.format('DD/MM/YYYY HH:mm')}
                </span>
              </div>
              <div className="calibration--box--datas--data">
                {calibration2?.attributes.data.map((data) => {
                  return (
                    <div key={data.name}>
                      {data.name}: {data.value}
                    </div>
                  );
                })}
              </div>
            </div>
          </Grid>
          <LoadingButton
            sx={{ marginTop: '25px' }}
            variant={'contained'}
            loading={loading}
            onClick={() => {
              setLoading(true);
              sendEmailToUpdateCalibration();
            }}
          >
            {t('send_calibration')}
          </LoadingButton>
        </Grid>
      </BasicModalExpanded>
    </Grid>
  );
}

export default DeviceDetailsGraph;
